/**
 * Auth Store — 轻量级权限状态管理
 * 使用 Vue 3 reactive，不依赖 Pinia/Vuex
 */
import { reactive, computed } from "vue";

const state = reactive({
  token: localStorage.getItem("token") || "",
  user: JSON.parse(localStorage.getItem("user") || "null"),
});

/** 是否已登录 */
const isLoggedIn = computed(() => !!state.token && !!state.user);

/** 当前用户角色 */
const role = computed(() => state.user?.role || null);

/** 设置认证信息（登录成功后调用） */
function setAuth(token, user) {
  state.token = token;
  state.user = user;
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("username", user?.nickname || user?.username || "");
}

/** 清除认证信息（退出登录或 token 过期时调用） */
function clearAuth() {
  state.token = "";
  state.user = null;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
}

/** 更新用户信息（刷新 /auth/me 后调用） */
function setUser(user) {
  state.user = user;
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("username", user?.nickname || user?.username || "");
}

export const authStore = {
  state,
  isLoggedIn,
  role,
  setAuth,
  clearAuth,
  setUser,
};
